export default function DellerReplaseAcount(){
return(
    <>
    <h1>DellerReplaseAcount</h1>
    </>
);
}